<template>
  <div>
    <el-tooltip :content="$t('accountAdditionalDetails.update.btnTooltip')"
                effect="light"
                :open-delay="300"
                placement="bottom">
      <base-button size="md" icon round type="info" @click="modal = true" class="zi_100" :disabled="updating">
        <span class="mdi mdi-24px mdi-pencil-outline"/>
      </base-button>
    </el-tooltip>

    <modal :show.sync="modal"
           showClose
           modal-classes="modal-dialog-centered modal-lg"
           @close="resetForm()"
           key="accountAdditionalDetails.update">
      <template slot="header">
        <h4 class="modal-title">
          {{ $t('accountAdditionalDetails.update.titleText') }}
        </h4>
      </template>
      <template>
        <div class="text-center text-muted mb-4">
          <small>{{ $t('accountAdditionalDetails.update.helpText') }}</small>
        </div>
        <base-alert v-if="alert" dismissible :dismiss-callback="() => alert=false" type="danger">
          <!-- TODO: add error translation -->
          {{ getActionErrorDetails }}
        </base-alert>
        <form role="form" @submit.prevent="validate()">
          <div class="row">
            <label class="col-sm-3 col-form-label">{{
                $t('accountAdditionalDetails.details.person_identifier')
              }}</label>
            <div class="col-sm-9">
              <base-input
                type="text"
                name="identifier"
                v-validate="modelValidations.required"
                :error="getError('identifier')"
                v-model="formDetails.person_identifier">
              </base-input>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('accountAdditionalDetails.details.name') }}</label>
            <div class="col-sm-9">
              <base-input
                type="text"
                name="personal_data__name"
                :error="getError('personal_data__name')"
                v-model="formDetails.data.personal_data.name"
                :disabled="formDetails.excludePersonalData">
              </base-input>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('accountAdditionalDetails.details.surname') }}</label>
            <div class="col-sm-9">
              <base-input
                type="text"
                name="personal_data__name"
                :error="getError('personal_data__surname')"
                v-model="formDetails.data.personal_data.surname">
              </base-input>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('accountAdditionalDetails.form.includeContacts') }}</label>
            <div class="col-sm-9">
              <base-checkbox
                inline
                v-model="formDetails.includeContacts"
              ></base-checkbox>
            </div>
          </div>
          <div class="row" v-if="formDetails.includeContacts">
            <label class="col-sm-3 col-form-label">{{ $t('accountAdditionalDetails.details.address') }}</label>
            <div class="col-sm-9">
              <base-input
                type="text"
                name="address"
                :error="getError('address')"
                v-model="formDetails.data.contacts.address">
              </base-input>
            </div>
          </div>
          <div class="row" v-if="formDetails.includeContacts">
            <label class="col-sm-3 col-form-label">{{ $t('accountAdditionalDetails.details.phone_number') }}</label>
            <div class="col-sm-9">
              <base-input
                type="text"
                name="phone_number"
                :error="getError('phone_number')"
                v-model="formDetails.data.contacts.phone_number">
              </base-input>
            </div>
          </div>
          <div class="row" v-if="formDetails.includeContacts">
            <label class="col-sm-3 col-form-label">{{ $t('accountAdditionalDetails.details.email_address') }}</label>
            <div class="col-sm-9">
              <base-input
                type="text"
                name="email_address"
                :error="getError('email_address')"
                v-validate="modelValidations.email"
                v-model="formDetails.data.contacts.email_address">
              </base-input>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('accountAdditionalDetails.form.includeAssignee') }}</label>
            <div class="col-sm-9">
              <base-checkbox
                inline
                v-model="formDetails.includeAssignee"
              ></base-checkbox>
            </div>
          </div>
          <div class="row" v-if="formDetails.includeAssignee">
            <label class="col-sm-3 col-form-label">{{ $t('accountAdditionalDetails.details.name') }}</label>
            <div class="col-sm-9">
              <base-input
                type="text"
                name="assignee__name"
                :error="getError('assignee__name')"
                v-model="formDetails.data.assignee.name">
              </base-input>
            </div>
          </div>
          <div class="row" v-if="formDetails.includeAssignee">
            <label class="col-sm-3 col-form-label">{{ $t('accountAdditionalDetails.details.surname') }}</label>
            <div class="col-sm-9">
              <base-input
                type="text"
                name="assignee__surname"
                :error="getError('assignee__surname')"
                v-model="formDetails.data.assignee.surname">
              </base-input>
            </div>
          </div>
          <div class="row" v-if="formDetails.includeAssignee">
            <label class="col-sm-3 col-form-label">{{
                $t('accountAdditionalDetails.details.person_identifier')
              }}</label>
            <div class="col-sm-9">
              <base-input
                type="text"
                name="assignee__person_identifier"
                :error="getError('assignee__person_identifier')"
                v-model="formDetails.data.assignee.person_identifier">
              </base-input>
            </div>
          </div>
          <div class="row" v-if="formDetails.includeAssignee">
            <label class="col-sm-3 col-form-label">{{ $t('accountAdditionalDetails.details.relation') }}</label>
            <div class="col-sm-9">
              <base-input
                type="text"
                name="relation"
                :error="getError('relation')"
                v-model="formDetails.data.assignee.relation">
              </base-input>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('accountAdditionalDetails.form.includeDocument') }}</label>
            <div class="col-sm-9">
              <base-checkbox
                inline
                v-model="formDetails.includeDocument"
              ></base-checkbox>
            </div>
          </div>
          <div class="row" v-if="formDetails.includeDocument">
            <label class="col-sm-3 col-form-label">{{ $t('accountAdditionalDetails.details.document_type') }}</label>
            <div class="col-sm-9">
              <base-input
                type="text"
                name="document_type"
                :error="getError('document_type')"
                v-model="formDetails.data.document.type">
              </base-input>
            </div>
          </div>
          <div class="row" v-if="formDetails.includeDocument">
            <label class="col-sm-3 col-form-label">{{
                $t('accountAdditionalDetails.details.document_identifier')
              }}</label>
            <div class="col-sm-9">
              <base-input
                type="text"
                name="document_identifier"
                :error="getError('document_identifier')"
                v-model="formDetails.data.document.document_identifier">
              </base-input>
            </div>
          </div>

          <div class="text-center">
            <base-button
              type="info"
              :loading="updating"
              class="my-4"
              native-type="submit"
            >{{ $t('accountAdditionalDetails.update.actionBtnLabel') }}
            </base-button>
          </div>
        </form>
      </template>
    </modal>
  </div>
</template>


<script>
import {BaseAlert, Modal} from 'src/components';
import {Option, Select} from 'element-ui';
import {mapActions, mapState} from "vuex";

export default {
  name: 'UpdateAccountAdditionalDetailsBtn',
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    Modal,
    BaseAlert
  },
  data() {
    return {
      modal: false,
      alert: false,
      loading: false,
      formDetails: {
        person_identifier: this.currentDetails.data.personal_data.person_identifier,
        includeContacts: this.currentDetails.data.contacts != null,
        includeAssignee: this.currentDetails.data.assignee != null,
        includeDocument: this.currentDetails.data.document != null,
        data: {
          personal_data: {
            name: this.currentDetails.data.personal_data ? this.currentDetails.data.personal_data.name : '',
            surname: this.currentDetails.data.personal_data ? this.currentDetails.data.personal_data.surname : '',
            // person_identifier: ''
          },
          contacts: {
            address: this.currentDetails.data.contacts ? this.currentDetails.data.contacts.address : '',
            phone_number: this.currentDetails.data.contacts ? this.currentDetails.data.contacts.phone_number : '',
            email_address: this.currentDetails.data.contacts ? this.currentDetails.data.contacts.email_address : ''
          },
          assignee: {
            name: this.currentDetails.data.assignee ? this.currentDetails.data.assignee.name : '',
            surname: this.currentDetails.data.assignee ? this.currentDetails.data.assignee.surname : '',
            company: this.currentDetails.data.assignee ? this.currentDetails.data.assignee.company : '',
            person_identifier: this.currentDetails.data.assignee ? this.currentDetails.data.assignee.person_identifier : '',
            relation: this.currentDetails.data.assignee ? this.currentDetails.data.assignee.relation : '',
          },
          document: {
            type: this.currentDetails.data.document ? this.currentDetails.data.document.type : '',
            document_identifier: this.currentDetails.data.document ? this.currentDetails.data.document.document_identifier : ''
          },
        }
      },
      modelValidations: {
        required: {
          required: true
        },
        email: {
          email: true
        },
      }
    }
  },
  props: {
    currentDetails: {
      type: Object,
      required: false,
    },
  },
  computed: {
    ...mapState({
      updating: state => state.account_additional_details.updating,
      error: state => state.account_additional_details.error,
      // data: state => state.account_additional_details.data,
    }),
    getActionErrorDetails() {
      return this.error ? this.error.bodyText : null;
    }
  },
  methods: {
    ...mapActions(['UpdateAccountAdditionalDetails', 'LoadAccount']),
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function () {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.create()
        }
      });
    },
    create: function () {
      let payload = {
        person_identifier: this.formDetails.person_identifier,
        data: {
          personal_data: {
            name: this.formDetails.data.personal_data.name,
            surname: this.formDetails.data.personal_data.surname,
            person_identifier: this.formDetails.person_identifier
          },
          contacts: {
            address: this.formDetails.data.contacts.address,
            phone_number: this.formDetails.data.contacts.phone_number,
            email_address: this.formDetails.data.contacts.email_address
          },
          assignee: {
            name: this.formDetails.data.assignee.name,
            surname: this.formDetails.data.assignee.surname,
            company: this.formDetails.data.assignee.company,
            person_identifier: this.formDetails.data.assignee.person_identifier,
            relation: this.formDetails.data.assignee.relation
          },
          document: {
            type: this.formDetails.data.document.type,
            document_identifier: this.formDetails.data.document.document_identifier
          },
        }
      }

      if (this.formDetails.includeContacts === false) {
        payload.data.contacts = null;
      }

      if (this.formDetails.includeAssignee === false) {
        payload.data.assignee = null;
      }

      if (this.formDetails.includeDocument === false) {
        payload.data.document = null;
      }

      this.UpdateAccountAdditionalDetails({
        accountId: this.currentDetails.account_id,
        id: this.currentDetails.id,
        data: payload
      }).then(() => {
        if (this.error != null) {
          this.alert = true
          // got error, don't reset form
        } else {
          this.$notify({
            type: 'success',
            message: this.$t('accountAdditionalDetails.update.successNotification'),
            icon: 'tim-icons icon-alert-circle-exc'
          })
          this.LoadAccount(this.currentDetails.account_id)
          this.resetForm();
        }
      });
    },
    resetForm: function () {
      // closing dialog
      this.modal = false;

      // resetting alerts
      this.alert = false;

      // // resetting form
      // this.formDetails = {
      //   person_identifier: '',
      //   includeContacts: false,
      //   includeAssignee: false,
      //   includeDocument: false,
      //   data: {
      //     personal_data: {
      //       name: '',
      //       surname: '',
      //       person_identifier: ''
      //     },
      //     contacts: {
      //       address: '',
      //       phone_number: '',
      //       email_address: ''
      //     },
      //     assignee: {
      //       name: '',
      //       surname: '',
      //       company: '',
      //       person_identifier: '',
      //       relation: ''
      //     },
      //     document: {
      //       type: '',
      //       document_identifier: ''
      //     },
      //   }
      // },

      // reset validation errors
      this.$validator.reset()
    }
  }
}
</script>
